// Configuration d'affichage de la section Frais. Aucun calcul de frais ici : les montants viennent tous du
// fees-manager (GET /fees/schedule, POST /fees/simulate/:type). Ce fichier ne fait que nommer les variables,
// décrire les produits simulables et construire les requêtes envoyées au fees-manager.

// Produits de la grille, dans l'ordre d'affichage
export const PRODUCTS = [
    { key: 'classic', title: 'Actions classiques', note: 'Achat, vente et playlists. Fixe sous le premier seuil, fixe jusqu’au second, puis un pourcentage.' },
    { key: 'etf', title: 'ETF', note: 'Trades directs. Les ETF copiés suivent la grille copy classique.' },
    { key: 'ipo', title: 'IPO', note: 'Fixe jusqu’au seuil, puis un pourcentage.' },
    { key: 'copy', title: 'Copy trading', note: 'Tous les signal providers, jamais les trades directs. Vide = grille directe. Classique : max(minimum, % de l’ordre), jamais au-dessus du classique. Levier : mêmes paliers que le direct, minimum plus bas.' },
    { key: 'margin', title: 'Levier', note: 'Actions Exante : marchés en % (EU) et marchés par action (US, TMX). LMAX : forex, métaux, indices.' },
    { key: 'overnight', title: 'Overnight (levier)', note: 'Taux Exante + taux Goliaths sur la valeur de la position, avec un minimum. Pas d’overnight sur le forex.' },
    { key: 'fx', title: 'Markup FX', note: 'Sur les ordres en devise étrangère.' },
    { key: 'structured', title: 'Produits structurés', note: 'Frais de plateforme fixes (réduits pour Paradox) + frais d’émission en % du montant net.' },
    { key: 'card', title: 'Paiement par carte', note: 'Visa / Mastercard de l’EEE, Apple Pay et Google Pay : grille par montant. Autres cartes : taux 2.' },
    { key: 'broker', title: 'Plancher broker', note: 'Le prix client ne descend jamais sous ce que coûte l’ordre chez Exante / LMAX (avant et après remise).' }
];

export const VARIABLE_LABELS = {
    TRADE_FIRST_THRESHOLD: 'Premier seuil',
    COMMISSION_SMALL_TRADE: 'Commission sous le premier seuil',
    TRADE_SECOND_THRESHOLD: 'Second seuil',
    COMMISSION_TRADE: 'Commission entre les deux seuils',
    COMMISSION_TRADE_PERC: 'Commission au-delà du second seuil',
    COMMISSION_MICRO_TRADE: 'Commission micro-trade (ordre plus petit que la commission)',
    TRADE_ETF_THRESHOLD: 'Seuil ETF',
    COMMISSION_TRADE_ETF: 'Commission ETF sous le seuil',
    COMMISSION_TRADE_ETF_PERC: 'Commission ETF au-delà du seuil',
    TRADE_IPO_THRESHOLD: 'Seuil IPO',
    COMMISSION_TRADE_IPO: 'Commission IPO sous le seuil',
    COMMISSION_TRADE_IPO_PERC: 'Commission IPO au-delà du seuil',
    FXMARKUP: 'Markup FX (classique)',
    MINIMUM_MARKUP: 'Markup FX minimum',
    FXMARKUP_MARGIN: 'Markup FX (levier)',
    FXMARKUP_MARGIN_METALS: 'Markup FX (levier, métaux)',
    MARGIN_EU_TIERS_MAX: 'Paliers EU (bornes hautes)',
    MARGIN_EU_PERC: 'Commission EU par palier',
    MARGIN_EU_MIN_FEE: 'Minimum EU',
    MARGIN_US_TIERS_MAX: 'Paliers US (bornes hautes)',
    MARGIN_US_PERC: 'Commission US par palier',
    MARGIN_US_MIN_FEE: 'Minimum US par palier',
    MARGIN_US_PER_SHARE: 'Commission US par action, par palier',
    MARGIN_FOREX_PERC: 'Forex (hors LMAX)',
    LMAX_MARGIN_METAL_PERC_UNDER_100K: 'LMAX forex / métaux < 100 k€',
    LMAX_MARGIN_METAL_PERC_UNDER_200K: 'LMAX forex / métaux < 200 k€',
    LMAX_MARGIN_METAL_PERC_OVER_200K: 'LMAX forex / métaux ≥ 200 k€',
    COMMISSION_MARGIN_UNDER_2500: 'LMAX hors forex, position < 2 500 €',
    MARGIN_TRADE_PERC: 'LMAX hors forex, position ≥ 2 500 €',
    MARGIN_OVERNIGHT_RATE_EXANTE: 'Taux overnight Exante',
    MARGIN_OVERNIGHT_RATE_GOLIATHS: 'Taux overnight Goliaths',
    MINIMUM_OVERNIGHT_RATE: 'Overnight minimum',
    COPY_MARGIN_MIN_FEE_EU: 'Levier copy : minimum EU',
    COPY_MARGIN_MIN_FEE_US: 'Levier copy : minimum US',
    COPY_INVEST_MIN_FEE: 'Classique copy : minimum',
    COPY_INVEST_PERC: 'Classique copy : % de l’ordre',
    FIXED_COMMISSION_STRUCTURED_PRODUCT: 'Frais de plateforme',
    PERC_COMMISSION_STRUCTURED_PRODUCT: 'Frais d’émission',
    PARADOX_REDUCTION_PERC: 'Réduction Paradox sur les frais de plateforme',
    PERCENTAGE_COMMISSION_CB_RATE_TEMP: 'Grille EEE : pourcentage',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_50: 'Grille EEE : fixe ≤ 50 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_250: 'Grille EEE : fixe ≤ 250 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_500: 'Grille EEE : fixe ≤ 500 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_1000: 'Grille EEE : fixe ≤ 1 000 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_1500: 'Grille EEE : fixe ≤ 1 500 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_2000: 'Grille EEE : fixe ≤ 2 000 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_3000: 'Grille EEE : fixe ≤ 3 000 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_4000: 'Grille EEE : fixe ≤ 4 000 €',
    FIXED_COMMISSION_CB_EU_RATE_UNDER_6000: 'Grille EEE : fixe ≤ 6 000 €',
    FIXED_COMMISSION_CB_EU_RATE_OVER_6000: 'Grille EEE : fixe > 6 000 €',
    PERCENTAGE_COMMISSION_CB_RATE_2: 'Taux 2 (autres cartes) : pourcentage',
    FIXED_COMMISSION_CB_RATE_2: 'Taux 2 (autres cartes) : fixe',
    BROKER_FEES_FLOOR_ENABLED: 'Plancher broker actif'
};

export const SUBSCRIPTION_LABELS = { goliaths_plus: 'Goliaths+', paradox: 'Paradox' };

export const CAMPAIGN_LABELS = {
    classic_fees_discount: 'Remise frais classiques',
    margin_fees_discount: 'Remise frais levier',
    reduced_fees_category: 'Remise par catégorie',
    no_fees: '0 frais'
};

// Marchés simulables. `exchange` et `type` choisissent la règle broker (Redis broker_fees:<type>:<exchange>).
export const MARKETS = {
    eu_exante: { label: 'Action EU (Exante)', ticker: 'SIM.EURONEXT', type: 'exante', exchange: 'EURONEXT', currency: 'EUR', sector: 'tech', is_forex: false, price: 100 },
    us_exante: { label: 'Action US (Exante)', ticker: 'SIM.NASDAQ', type: 'exante', exchange: 'NASDAQ', currency: 'USD', sector: 'tech', is_forex: false, price: 100 },
    us_alpaca: { label: 'Action US (Alpaca)', ticker: 'SIM', type: 'us_equity', exchange: null, currency: 'USD', sector: 'tech', is_forex: false, price: 100 },
    forex_lmax: { label: 'Forex (LMAX)', ticker: 'EUR/USD.E.FX', type: 'lmax', exchange: 'FOREX', currency: 'USD', sector: 'forex', is_forex: true, price: 1 },
    metal_lmax: { label: 'Métaux (LMAX)', ticker: 'XAU/USD.E.FX', type: 'lmax', exchange: 'METAL', currency: 'USD', sector: 'forex metal', is_forex: true, price: 1 },
    index_lmax: { label: 'Indices (LMAX)', ticker: 'SIM.INDEX', type: 'lmax', exchange: 'INDEX', currency: 'USD', sector: 'index', is_forex: false, price: 100 }
};

const CLASSIC_MARKETS = ['eu_exante', 'us_alpaca'];
const MARGIN_MARKETS = ['eu_exante', 'us_exante', 'forex_lmax', 'metal_lmax', 'index_lmax'];

export const PAYMENT_METHODS = {
    wallet: { label: 'Wallet', method: 'wallet', card: 'eea' },
    card_eea: { label: 'Carte EEE (Visa / Mastercard)', method: 'card', card: 'eea' },
    card_non_eea: { label: 'Carte hors EEE', method: 'card', card: 'non_eea' },
    apple_pay: { label: 'Apple Pay / Google Pay', method: 'apple_pay', card: 'eea' }
};

const qtyOf = (amount, market, price) => market.is_forex ? amount : Math.max(1, Math.floor(amount / price));

// Le bloc broker d'un ordre copy : `orders` ordres de la même taille groupés en un seul ordre Exante / LMAX
const batchOf = (amount, qty, orders) => ({ value_eur: amount * orders, qty: qty * orders });

const document = (m) => ({ ticker: m.ticker, type: m.type, exchange: m.exchange, currency: m.currency, sector: m.sector, is_forex: m.is_forex });

/**
 * Produits simulables : `type` = handler du fees-manager, `build` = payload envoyé pour un montant donné.
 * Options lues par build : market, price, payment, isEtf, leverage, orders (taille du bloc copy).
 */
export const SIM_PRODUCTS = {
    buy: {
        label: 'Achat action', type: 'ticker_qty', markets: CLASSIC_MARKETS, payment: true, etf: true,
        build: (a, o) => { const m = MARKETS[o.market]; const qty = qtyOf(a, m, o.price); return { amount_to_buy: a, method: PAYMENT_METHODS[o.payment].method, card_id: 'simulation', currency: m.currency, isEtf: o.isEtf, ticker: m.ticker, type: m.type, qty }; }
    },
    sell: {
        label: 'Vente action', type: 'ticker_sell', markets: CLASSIC_MARKETS, etf: true,
        build: (a, o) => { const m = MARKETS[o.market]; return { total_eur: a, isEtf: o.isEtf, currency: m.currency, ticker: m.ticker, type: m.type, qty: qtyOf(a, m, o.price), document: { ticker: m.ticker, sector: m.sector } }; }
    },
    playlist: {
        label: 'Playlist', type: 'playlist', payment: true,
        build: (a, o) => ({ total_eur: a, method: PAYMENT_METHODS[o.payment].method, card_id: 'simulation', is_signal_provider: false })
    },
    ipo: {
        label: 'IPO', type: 'ipo', payment: true,
        build: (a, o) => ({ total_eur: a, method: PAYMENT_METHODS[o.payment].method, card_id: 'simulation', document: { ticker: null, sector: '' } })
    },
    copy_classic: {
        label: 'Copy classique (achat ou vente)', type: 'copy_invest', markets: CLASSIC_MARKETS, etf: true, copy: true,
        build: (a, o) => { const m = MARKETS[o.market]; const qty = qtyOf(a, m, o.price); return { total_eur: a, isEtf: o.isEtf, currency: m.currency, ticker: m.ticker, type: m.type, qty, ...(o.orders > 1 && { batch: batchOf(a, qty, o.orders) }) }; }
    },
    margin_open: {
        label: 'Levier : ouverture', type: 'margin_open', markets: MARGIN_MARKETS, leverage: true,
        build: (a, o) => marginOpen(a, o, false)
    },
    margin_close: {
        label: 'Levier : fermeture', type: 'margin_close', markets: MARGIN_MARKETS,
        build: (a, o) => marginClose(a, o, false)
    },
    copy_margin_open: {
        label: 'Copy levier : ouverture', type: 'margin_open', markets: MARGIN_MARKETS, leverage: true, copy: true,
        build: (a, o) => marginOpen(a, o, true)
    },
    copy_margin_close: {
        label: 'Copy levier : fermeture', type: 'margin_close', markets: MARGIN_MARKETS, copy: true,
        build: (a, o) => marginClose(a, o, true)
    },
    structured: {
        label: 'Produit structuré', type: 'structured_product', payment: true,
        build: (a, o) => ({ total_eur: a, method: PAYMENT_METHODS[o.payment].method })
    }
};

function marginOpen(a, o, copy) {
    const m = MARKETS[o.market];
    const qty = qtyOf(a, m, o.price);
    return {
        amount_to_buy: a / Math.max(1, o.leverage), total_money: a, document: document(m),
        ticker_value: m.is_forex ? 1 : o.price, qty, eur_rate: 1, with_partners: true,
        signal_provider_uuid: copy ? 'simulation_provider' : null,
        ...(copy && o.orders > 1 && { batch: batchOf(a, qty, o.orders) })
    };
}

function marginClose(a, o, copy) {
    const m = MARKETS[o.market];
    const qty = qtyOf(a, m, o.price);
    // margin_close prend comme valeur de l'ordre close_qty (forex) ou close_qty × prix : le bloc dans la même unité
    const order_value = m.is_forex ? qty : qty * o.price;
    return {
        amount_to_sell: a, close_qty: qty, estimated_ticker_value: m.is_forex ? 1 : o.price, document: document(m),
        signal_provider_uuid: copy ? 'simulation_provider' : null,
        ...(copy && o.orders > 1 && { batch: batchOf(order_value, qty, o.orders) })
    };
}

/**
 * Lignes du détail d'un résultat du fees-manager (les champs varient selon le handler). Uniquement de la mise
 * en forme : le total client est la somme des postes renvoyés, la marge = commission - coût broker - partenaires.
 */
export function resultRows(r) {
    if (!r) return [];
    const n = (v) => (v === undefined || v === null || v === '' ? null : Number(v));
    if (r.emission_fees !== undefined) { // produit structuré
        const commission = n(r.commission_trade);
        return [
            { key: 'platform', label: 'Frais de plateforme', value: n(r.platform_fees) },
            { key: 'paradox', label: 'dont réduction Paradox', value: n(r.paradox_discount), minus: true },
            { key: 'emission', label: 'Frais d’émission', value: n(r.emission_fees) },
            { key: 'card', label: 'Frais carte', value: n(r.cb_commission) },
            { key: 'total', label: 'Total payé par le client', value: n(r.fees), strong: true },
            { key: 'partners', label: 'Part partenaire + sales', value: (n(r.partner_commission) || 0) + (n(r.sales_commission) || 0) },
            { key: 'margin', label: 'Revenu Goliaths (hors carte)', value: commission - (n(r.partner_commission) || 0) - (n(r.sales_commission) || 0), strong: true }
        ];
    }
    const commission = n(r.commission_trade ?? r.commission_playlist);
    const before = n(r.commission_trade_without_discount ?? r.commission_playlist_without_discount);
    const parts = [commission, n(r.comission_markup), n(r.cb_commission), n(r.overnight_rate_fee), n(r.legal_fees)];
    const total = parts.reduce((acc, v) => acc + (v || 0), 0);
    const broker = n(r.broker_fees);
    const partners = (n(r.partner_commission) || 0) + (n(r.sales_commission) || 0);
    const rows = [
        { key: 'before', label: 'Commission avant remise', value: before ?? commission },
        { key: 'discount', label: r.discount_source ? `Remise (${SUBSCRIPTION_LABELS[r.discount_source] || r.discount_source})` : 'Remise', value: n(r.discount), minus: true },
        { key: 'commission', label: 'Commission payée', value: commission, strong: true },
        { key: 'markup', label: 'Markup FX', value: n(r.comission_markup) },
        { key: 'card', label: 'Frais carte', value: n(r.cb_commission) },
        { key: 'overnight', label: 'Overnight (1re nuit)', value: n(r.overnight_rate_fee) },
        { key: 'legal', label: 'Taxes', value: n(r.legal_fees) },
        { key: 'total', label: 'Total payé par le client', value: total, strong: true },
        { key: 'broker', label: 'Coût broker (Exante / LMAX)', value: broker },
        { key: 'partners', label: 'Part partenaire + sales', value: partners },
        { key: 'margin', label: 'Marge sur la commission', value: commission - (broker || 0) - partners, strong: true }
    ];
    return rows.filter(row => row.value !== null && !(row.minus && !row.value) && !(['markup', 'card', 'overnight', 'legal', 'partners'].includes(row.key) && !row.value));
}

// Montant total payé par le client, pour la courbe
export const totalFees = (r) => resultRows(r).find(row => row.key === 'total')?.value ?? null;

export const CURVE_AMOUNTS = [10, 25, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000];
